<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <proveedor-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import ProveedorProvider from "../../../providers/ProveedorProvider";

import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

import ProveedorForm from "../ProveedorForm";

export default {
    name: "ProveedorCreate",

    components: { ProveedorForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "proveedor.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                nombre: null,
                cuit: null,
                email: null,
                telefono: null,
            },
        };
    },

    methods: {
        create() {
            this.$refs.form.validateThenConfirm(() => this.performCreate());
        },
        performCreate() {
            this.loading = true;
            ProveedorProvider.createProveedor(this.form)
                .then((r) => {
                    if (r) {
                        this.$emit("itemCreated", r.data.proveedorCreate);
                        this.$emit("close");
                    }
                })
                .catch((error) => {
                    let clientError = new ClientError(error);
                    this.inputErrors = clientError.inputErrors;
                    this.errorMessage = clientError.i18nMessage;
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style scoped></style>
